var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 10.1549L9.66732 11.8215L13.4173 8.07152M17.1673 10.5715C17.1673 14.6619 12.7057 17.6369 11.0823 18.5839C10.8978 18.6915 10.8056 18.7454 10.6754 18.7733C10.5744 18.7949 10.4269 18.7949 10.3259 18.7733C10.1957 18.7454 10.1035 18.6915 9.91899 18.5839C8.29562 17.6369 3.83398 14.6619 3.83398 10.5715V6.58619C3.83398 5.91993 3.83398 5.5868 3.94295 5.30044C4.03921 5.04747 4.19564 4.82175 4.3987 4.64279C4.62856 4.44022 4.94048 4.32325 5.56432 4.08931L10.0325 2.41375C10.2057 2.34878 10.2924 2.3163 10.3815 2.30342C10.4605 2.292 10.5408 2.292 10.6198 2.30342C10.7089 2.3163 10.7956 2.34878 10.9688 2.41375L15.437 4.08931C16.0608 4.32325 16.3727 4.44022 16.6026 4.64279C16.8057 4.82175 16.9621 5.04747 17.0584 5.30044C17.1673 5.5868 17.1673 5.91993 17.1673 6.58619V10.5715Z",
    stroke: "#32CC86",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.d7fa3cbba955716e0cbd4c013c96b4d8.svg";
export { ForwardRef as ReactComponent };